import { Grid, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BusinessCard from './BusinessCard';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorDisplay from '../common/ErrorDisplay';

/**
 * Business list component for displaying grid of businesses
 */
const BusinessList = ({ 
  businesses = [], 
  loading = false, 
  error = null,
  onRetry = null,
  title = null,
  emptyMessage = null,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return <LoadingSpinner message={t('common.loading')} />;
  }

  if (error) {
    return <ErrorDisplay message={error} onRetry={onRetry} />;
  }

  if (!businesses || businesses.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          {emptyMessage || t('home.noBusinesses')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {title && (
        <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
          {title}
        </Typography>
      )}
      <Grid container spacing={3}>
        {businesses.map((business) => (
          <Grid 
            item 
            key={`${business.customerId}-${business.id}`} 
            xs={12} 
            sm={6} 
            md={4}
          >
            <BusinessCard business={business} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BusinessList;
